/**
 * Logto configuration and provider setup
 */
import { LogtoConfig } from '@logto/react';

// Logto configuration - using environment variables (required, no fallbacks)
export const logtoConfig: LogtoConfig = {
  endpoint: import.meta.env.VITE_LOGTO_ENDPOINT,
  appId: import.meta.env.VITE_LOGTO_APP_ID,
  // Scopes to request from Logto
  scopes: ['openid', 'profile', 'email'],
  // Resources (API identifiers) - optional, for API access tokens
  // resources: ['https://your-api.example.com'],
};

// Re-export for convenience
export { LogtoProvider, useLogto } from '@logto/react';
export type { UserInfoResponse, IdTokenClaims } from '@logto/react';
